import { istClock, journeyParts, useNow } from "@/hooks/useNow";

function Pad({ v }) {
  return <span>{String(v).padStart(2, "0")}</span>;
}

export default function LifeClock({ compact = false }) {
  const now = useNow();
  const { time, date } = istClock(now);
  const j = journeyParts(now);

  if (compact) {
    return (
      <div className="flex items-center gap-3 font-mono text-[11px] text-slate-300" data-testid="life-clock-compact">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-green-400 pulse-dot" />
        <span>{time} IST</span>
        <span className="text-slate-500">·</span>
        <span className="text-slate-400">{j.days}d in the code mines</span>
      </div>
    );
  }

  return (
    <div className="glass-soft rounded-2xl p-5 sm:p-6" data-testid="life-clock">
      <div className="flex items-baseline justify-between gap-4">
        <div>
          <p className="eyebrow mb-1">Local time · Bengaluru</p>
          <p className="font-mono text-4xl sm:text-5xl font-semibold tracking-tight text-white tabular-nums" data-testid="life-clock-time">
            {time}
            <span className="text-sonoma caret-blink">_</span>
          </p>
          <p className="mt-1 font-mono text-xs text-slate-400">{date} · IST (UTC+5:30)</p>
        </div>
      </div>
      <div className="my-4 h-px bg-white/8" />
      <p className="eyebrow mb-2">Time coding · since Sep 2024</p>
      <div className="grid grid-cols-4 gap-2" data-testid="life-clock-journey">
        {[
          [j.days, "days"],
          [j.hours, "hrs"],
          [j.minutes, "min"],
          [j.seconds, "sec"],
        ].map(([v, l]) => (
          <div key={l} className="rounded-xl bg-white/[.04] border border-white/8 px-2 py-2.5 text-center">
            <p className="font-mono text-lg sm:text-xl font-semibold text-sky-300 tabular-nums">
              {l === "days" ? v : <Pad v={v} />}
            </p>
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
